import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';

const SocialAuthButtons = () => {
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      name: 'Microsoft',
      icon: 'Building2',
      color: 'bg-blue-600 hover:bg-blue-700',
      textColor: 'text-white',
      description: 'Sign in with Microsoft 365'
    },
    {
      name: 'Google',
      icon: 'Mail',
      color: 'bg-white hover:bg-gray-50 border border-border',
      textColor: 'text-foreground',
      description: 'Sign in with Google Workspace'
    }
  ];

  const handleSocialAuth = async (provider) => {
    setLoadingProvider(provider?.name);
    
    // Simulate OAuth flow
    setTimeout(() => {
      console.log(`Authenticating with ${provider?.name}`);
      // In a real app, this would redirect to OAuth provider
      setLoadingProvider(null);
    }, 2000);
  };

  return (
    <div className="w-full space-y-3">
      <div className="text-center mb-4">
        <p className="text-sm text-muted-foreground">
          Quick access with your enterprise account
        </p>
      </div>
      {socialProviders?.map((provider, index) => (
        <button
          key={index}
          onClick={() => handleSocialAuth(provider)}
          disabled={loadingProvider !== null}
          className={`w-full flex items-center justify-center space-x-3 px-4 py-3 rounded-lg nav-transition ${provider?.color} ${provider?.textColor} disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {loadingProvider === provider?.name ? (
            <>
              <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
              <span className="text-sm font-medium">
                Connecting...
              </span>
            </>
          ) : (
            <>
              <Icon 
                name={provider?.icon} 
                size={20} 
                className="text-current"
              />
              <span className="text-sm font-medium">
                {provider?.description}
              </span>
            </>
          )}
        </button>
      ))}
      {/* Enterprise SSO Option */}
      <div className="mt-6 p-4 bg-muted/50 rounded-lg border border-border">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Building" size={20} className="text-primary" />
          </div>
          <div className="flex-1">
            <h4 className="text-sm font-medium text-foreground">
              Enterprise SSO Available
            </h4>
            <p className="text-xs text-muted-foreground">
              Contact your IT administrator for SAML/OIDC setup
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialAuthButtons;